import Profile from "@system/config/profile";
import Auth from "@system/config/auth";
import { __remove, __set } from "../store/axios_indicator";
import Api from "./APIHandler";
import System from "src/helper/system";
import Helper from "src/helper/Helper";

const API = new Api({});
const { avUserInfoData: { salesOrg, accountNumber } } = System
class ProfileAPICall {

    getProfileAccountInformation = async (params = {}) => { // not in use now
        let res = {};
        let param = {};
        param.data = { ...params }
        try {
            __set("PROFILE_ACCOUNT_INFORMATION")
            await API.get(Profile.PROFILE_ACCOUNT_INFORMATION, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    res = resHer.data.data;
                }
            });
        } catch (err) {
            throw err;
        } finally {
            __remove("PROFILE_ACCOUNT_INFORMATION")
        }
        if (res) {
            res?.shipTo?.length > 0 ? (
                res.shipTo.map((item, i) => {
                    if (item.default === true) {
                        res.shipTo.splice(i, 1);
                        res.shipTo.unshift(item);
                    }
                }
                )) : [];

            let data_to_send = {
                accountInformation: {}
            };

            if (res) {
                data_to_send.accountInformation = res
                if (res.firstName) {
                    data_to_send.accountInformation.fullName = (res.firstName) + ' ' + (res.middleName ? res.middleName : '') + ' ' + (res.lastName ? res.lastName : '')
                }
                data_to_send.accountInformation.company = res.company ? res.company : ''
                data_to_send.accountInformation.jobFunction = res.jobFunction ? res.jobFunction : ''
                data_to_send.accountInformation.phoneNumber = res.phoneNumber ? res.phoneNumber : ''
                data_to_send.accountInformation.accountNumber = accountNumber ? accountNumber + (salesOrg ? '-' + salesOrg : '') : ''
            }

            return {
                data: data_to_send
            };
        } else {
            return res
        }
    };

    getHeaderAccountList = async () => {
        let res = {};
        await API.get(Profile.HEADER_ACCOUNT_LIST).then((resHer) => {
            if (resHer.data.isSuccessFull) {
                res = resHer.data.data;
            }
        });
        return res
    };
    setAccountAddressDefault = async (params) => {
        let res = false;
        let param = {};
        param.data = params
        await API.post(Auth.SAVE_USER_PREFRENCE_URL, param).then((resHer) => {
            if (resHer.data.data === "True") {
                res = true;
            }
        });
        return res
    };

    addProfileAddress = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        try {
            await API.post(Profile.ADD_PROFILE_ADDRESS_URL, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };

    validateProfileAddress = async (params = {}) => {
        let res = [];
        let param = {}
        param.data = params
        try {
            await API.post(Profile.VALIDATE_PROFILE_ADDRESS, param).then((resHer) => {
                if (resHer.data.isSuccessFull) {
                    if(Helper.valueIsNotNull(resHer?.data?.data)){
                        res = resHer?.data?.data
                    }
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    };

    editProfileInvoiceAddress = async (params = {}) => {
        let res = {};
        let param = {}
        param.data = params
        try {
            await API.put(Profile.ADD_PROFILE_ADDRESS_URL + `/${params.id}`, param).then((resHer) => {
                if (resHer.data) {
                    res = resHer?.data
                }
            });
        } catch (e) {
            res = e?.response?.data
        }
        return res;
    }

    setContactData = async (params = false) => {
        let res = {};
        const param = {}
        param.data = params
        await API.post(Profile.SET_CONTACT_INFORMATION, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };

    getCountryList = async () => {
        let res = {};
        await API.get(Profile.GET_COUNTRY_LIST, {}).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data
            }
        });
        return res;
    };

    getStateList = async (params = {}) => {
        let res = {};
        const param = {}
        param.params = params
        await API.get(Profile.GET_STATE_LIST, param).then((resHer) => {
            if (resHer?.data?.data) {
                res = resHer.data?.data
            }
        });
        return res;
    };

    getJobFunctionListData = async () => {
        let res = {};
        await API.get(Profile.GET_JOBFUNCTION_LIST, {}).then((resHer) => {

            if (resHer?.data) {
                res = resHer.data.data;
            }
        });

        return res
    };

    setAccountLinkData = async (params = false) => {
        let res = {};
        const param = {}
        param.data = params
        await API.post(Profile.SET_ACCOUNT_LINK_INFORMATION, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data
            }
        });
        return res;
    };
    
    checkValidAccount = async (params = false) => {
        let res = {};
        const param = {}
        param.params = params
        try {
            await API.post(Profile.CHEK_VALID_ACCOUNT, param).then((resHer) => {
                if (resHer?.data) {
                    res = resHer.data
                }
            });
        } catch (error) {
            res = error?.response?.data
        }

        return res;
    };

    fetchCarrierData = async (params = {}) => {
        let res = {};
        const param = {}
        param.data = params
        await API.post(Profile.GET_CARRIER_DATA_LIST, param).then((resHer) => {
            if (resHer?.data) {
                res = resHer.data?.data
            }
        });
        return res;
    };
}

export default ProfileAPICall;